export default {
  faq: {
    title: '자주 묻는 질문',
    bookingProcess: {
      title: '예약 진행',
      q1: '예약이 정상적으로 완료되었나요?',
      a1: `예약 확정시 등록된 메일 주소로 안내 메일을 보내드리고 있습니다. 이메일에 'E티켓 이용' 링크가 기재되어 있는 경우, 해당 링크에 접속하여 이용하시기 바랍니다.
  또한, 이메일 내 '예약 상세' 링크를 통해 예약 정보도 확인하실 수 있습니다.`,
      q2: '예약 확인 메일이 도착하지 않습니다. 어떻게 확인할 수 있을까요?',
      a2: `즉시 확정 상품은 5분 이내에 예약 확정/완료가 진행되며, 등록된 메일 주소로 안내 메일을 드리고 있습니다. 시간이 지나도 예약 확정 메일이 도착하지 않는 경우는 스팸 메일 폴더를 확인하여 주시기 바랍니다. '@linktivity.co.jp' 도메인으로 확정 메일이 전송됩니다.`,
      q3: '바우처 재발급이 가능한가요?',
      a3: `가능합니다. 예약하신 사이트에서 예약 정보와 바우처를 확인하실 수 있습니다.
1. 로그인 후 화면 우측 상단의 「마이페이지」 ＞ 「예약 정보」 클릭
2. 해당 예약의 「예약 상세 정보」 클릭
3. 바우처 정보란에서 원하는 바우처 클릭
「바우처 재발송」을 통해 등록하신 이메일 주소로 재발송도 가능합니다.`
    },
    payments: {
      title: '결제',
      q1: '결제 단계에서 예약 실패라는 문구가 표시됩니다.',
      a1: `예약 실패라는 문구가 표시된 경우, 약 5분 후 마이페이지의 예약정보를 한번 더 확인 해주시고, 예약이 확정 되지않았음을 확인 후 재예약해주시기 바랍니다.`,
      q2: '영수증 발행이 가능한가요?',
      a2: `영수증 발행은 현재 시스템에서는 지원을 하고 있지 않습니다. 
  다만, 개인용으로 필요하신 경우는 예약번호와 함께 <helpcenter@linktivity.co.jp>으로 문의하여 주시기 바랍니다.`,
      q3: '결제 수단은 어떤 것들이 있나요?',
      a3: `결제시 신용카드를 이용하실 수 있습니다.
  (Alipay, WeChat Pay로 결제 가능한 상품도 있습니다.)
  편의점 결제, 현금 결제는 불가한 점 양해바랍니다.`,
      q4: '3D시큐어란 무엇인가요?',
      a4: `3D시큐어는 인터넷에서 신용카드 결제를 보다 안전하게 하기 위한 본인인증 서비스입니다.
  신용카드 정보유출에 의한 명의도용 등 부정사용을 사전에 방지할 수 있습니다.
  3D시큐어에 등록된 신용카드로 결제할 경우, 주문 시 일회용 비밀번호 입력 등을 통해 카드 회원 본인 인증을 진행합니다. (카드사에 따라 인증 방법은 상이합니다.)`,
      q5: `3D시큐어 등록 방법을 알려주세요. 카드가 3D 시큐어를 지원하는지 모르겠습니다.`,
      a5: `3D시큐어는 사용하시는 카드사에 사전 등록을 하시면 이용하실 수 있습니다.
  카드 뒷면에 기재된 카드사 연락처를 통해 3D 시큐어 지원 여부 및 설정 방법에 대해 문의해 주시기 바랍니다.`,
      q6: `3D시큐어 비밀번호를 모르겠어요. 3D시큐어 일회용 비밀번호를 받지 못했어요.`,
      a6: `3D시큐어 인증 화면에서 필요한 비밀번호는 카드사에 사전 등록하신 비밀번호 또는 일회용 비밀번호입니다.
  일회용 비밀번호가 도착하지 않는 경우, 스팸메일 폴더에 도착했을 가능성이 있으니 스팸메일 폴더를 확인하시기 바랍니다.
  비밀번호를 모르시거나 일회용 비밀번호를 받지 못한 경우, 카드 뒷면에 기재된 카드사 연락처로 문의해 주시기 바랍니다.`,
      q7: `3D시큐어 인증가능한 신용카드만 사용할 수 있나요?`,
      a7: `3D시큐어 인증불가한 카드는 사용할 수 없습니다. 보안을 위해 필히 양해 부탁드립니다. *최근 카드부정사용이 급증함에 따라 일본 경제산업성은 2025년 3월 말부터 전자상거래 사이트에 본인인증(EMV 3-D 시큐어) 도입을 의무화한다고 발표했습니다.
  또한 2023년 3월에 발행된 '신용카드 보안 가이드라인【4.0판】'에는 EC사업자, 카드사 및 결제대행사업자를 대상으로 '본인인증 도입 의무화 및 이에 대한 대응'이라는 내용이 추가되었습니다. 새로운 인터넷 예약 시스템에서는 이 가이드라인에 따라 3D 시큐어를 필수로 하는 결제 시스템을 도입하고 있습니다.`,
      q8: `직불카드(체크카드)도 사용할 수 있나요?`,
      a8: `네, 가능합니다.`,
      q9: '3D 보안 설정이나 카드 이용 한도에도 문제가 없고, 다른 웹사이트에서는 항상 사용할 수 있는 카드인데도 오류가 발생해 결제가 되지 않습니다.',
      a9: `카드에 문제가 없는데도 결제가 되지 않는 경우, 카드사의 결제 승인 시스템이 '부정사용 의심 등'으로 판단하여 고객의 카드를 보호하기 위해 결제를 중단했을 가능성이 있습니다.
  사람의 판단과 달리 컴퓨터는 여러 가지 요소를 예측하여 판단을 하기 때문에 경우에 따라 결제 불가로 처리되는 경우가 있습니다.
  번거로우시겠지만, 다음 중 하나를 시도해 보시기 바랍니다.
  ・다른 카드로 결제 시도하기
  ・시간을 두고 다시 결제 시도하기
  ・카드사에 연락후 예약하고자 하는 티켓명과 상황을 설명해 주시고, 카드사 측에서 오류를 제거할 수 있도록 부정사용 감지 및 결제 승인 시스템 수정을 요청하기`,
      q10: '카드사로부터 이용 알림이 왔는데 마이페이지에 예약 정보가 없고, 예약 확정 메일도 오지 않습니다.',
      a10: `다음 중 한 가지 상황일 수 있습니다.
  ・이메일 주소 입력 오류(맞춤법 오류)
  ・평소 사용하던 이메일 주소와 다른 이메일 주소로 예약을 등록한 경우
  ・결제 및 예약이 미완료된 경우(카드 한도액 확보 단계까지는 진행되었으나, 일련의 오류로 인해 결제 및 예약이 미완료된 경우)
  혹시 기억나는 이메일 주소가 있다면, 해당 이메일 주소로 마이페이지에 로그인을 시도해 보시기 바랍니다.
  로그인할 수 없는 경우, 결제 및 예약 기록을 조회할 수 있도록 아래 정보를 기재하여 LINKTIVITY 고객지원팀<helpcenter@linktivity.co.jp>으로 메일을 보내주시기 바랍니다.
  -예약자 이름(영문):
  -참가 희망일:
  -결제하신 날짜 및 시간대(예: 3/2 19:00):
  -결제하신 카드 뒷자리 3자리:
  -결제한 카드의 유효기간:
  -금액:
  -예약에 사용했을 가능성이 있는 이메일 주소:`
    },
    changesAndCancellations: {
      title: '예약 변경 및 취소',
      q1: '예약을 잘못한 경우는 어떻게 해야 하나요?',
      a1: `취소가 가능한 상품의 경우는 하기와 같이 진행하여 주시기 바랍니다. 
  1. 계정 로그인 후 화면 상단 오른쪽 '마이페이지', '예약 상세'를 클릭하여 주십시오.
  2. 해당 예약의 '상세 보기'를 클릭하여 주십시오.
  3. 취소 정보에 있는 '취소 시작'을 클릭 후, '취소'를 클릭하시면 취소가 완료됩니다.`,
      q2: '취소하면 환불은 언제쯤 받아볼 수 있나요?',
      a2: `취소 수속 후 신용 카드 회사에 따라 환불 시기가 다를 경우가 있습니다. 정확한 환불 시기는 결제시 이용한 신용카드 회사로 문의를 부탁드립니다.`,
      q3: '예약 내용 변경이 가능한가요?',
      a3: `예약 내용 변경이 불가능합니다. 취소가 가능한 상품의 경우는 취소 후 재 예약을 진행하여 주시기 바랍니다. 
  상품 페이지 취소 정책을 참조하여 주시기 바랍니다.`
    },
    accounts: {
      title: '회원가입/계정',
      q1: '신규 회원 등록 방법을 알려주세요.',
      a1: `사이트 상단 오른쪽 '로그인'을 클릭하거나, 상품 예약 시 신규 회원 등록이 가능합니다. 
  현재 저희 사이트는 페이스북이나 구글등을 통한 계정 등록만 가능합니다.`,
      q2: '로그인 방법을 알려주세요.',
      a2: `예약한 사이트 상단 오른쪽에 '로그인'을 클릭하여 진행하여 주시기 바랍니다.`,
      q3: '비밀 번호를 잊어버렸습니다. 어떻게 해야하나요?',
      a3: `로그인 페이지에서 '비밀번호 찾기'를 클릭하시고 비밀번호 재설정을 진행하여 주시기 바랍니다.`,
      q4: '계정 삭제 방법을 알려주세요.',
      a4: `계정 삭제는 하기와 같이 진행하여 주시기 바랍니다. 
  1. 계정 로그인 후, 화면 상단 오른쪽 '마이페이지'에서 '프로필'을 클릭하여 주십시오.
  2. 화면 하단 오른쪽에 '계정 삭제'를 클릭하여 삭제를 진행하여 주시기 바랍니다. 
  *계정을 삭제하면 이전 기록이 삭제되며, 다시 이용을 원하시는 경우는 재등록을 하여주시기 바랍니다.`
    },
    environment: {
      title: '기타',
      q1: '추천 브라우저를 알려주세요.',
      a1: `・Firefox(최신판)
  ・Safari(최신판)
  ・Google Chrome(최신판)`,
      q2: '예약 확인 메일 발신자를 알려주세요.',
      a2: `'@linktivity.co.jp' 도메인을 사용하여 예약 확인 메일을 발송하고 있으며, 스팸 메일등으로 분류 되는 경우가 있기에 사전에 지정 수신 설정을 부탁드립니다.`
    },
    ticket: {
      title: 'E-ticket 이용',
      q1: '원타임 패스워드 인증이란 무엇인가요?',
      a1: `본 예약 시스템에서는 고객의 접속 환경(단말기, 브라우저 등)이 변경된 경우 일회용 비밀번호(1회용 비밀번호)를 이용하여 인증하여 제3자에 의한 디지털티켓의 부정사용을 방지합니다.
  E-ticket 이용시 사용하는 접속 환경과 다른 접속 환경에서 E-ticket 이용전 열람한 경우, 이 인증이 이루어집니다.
  당일 이용 시 당황하지 않도록 당일 이용할 단말기와 브라우저에서 E-Ticket을 미리 열어 확인하는 것을 권장합니다.
  예시:
  첫번째, A씨가 스마트폰으로 전자티켓을 열었을 때:원타임 패스워드 인증이 불필요
  두번째, A씨가 가족의 스마트폰으로 E-ticket을 열었을 때: 첫 번째와 다른 기기이므로 원타임 패스워드 인증을 요청하는 화면이 표시
  이때 입력한 이메일 주소가 시스템에 등록되고(고정), 세번째 다른 단말기로 열었을 때에도 이때 등록한 이메일 주소로 원타임패스워드가 전송됩니다. 따라서 이용 당일에도 현지에서 확인할 수 있는 이메일 주소로 원타임 패스워드를 보내는 것을 추천합니다.`,
      q2: `갑자기 '고객의 접속 환경이 변경되었습니다'라는 메시지가 떴습니다. 어떻게 E-ticket을 볼 수 있나요?`,
      a2: `고객님의 접속 환경이 변경되어(E-ticket을 처음 열었던 단말기와 다른 단말기 또는 다른 브라우저에서 열렸기 때문에) 원타임 패스워드 인증이 필요한 상태입니다. 메시지가 표시되면 먼저 원타임 패스워드를 보낼 이메일 주소를 입력해 주세요. 당일 현장에서도 확인할 수 있는 이메일 주소를 입력해 원타임 패스워드를 전송하는 것을 추천합니다. 입력한 이메일 주소로 원타임 패스워드가 도착했는지 확인후 메일 본문에 기재된 원타임 패스워드를 입력하세요. 비밀번호를 올바르게 입력하면 인증이 완료되고 E-티켓을 볼 수 있습니다.`,
      q3: '원타임 패스워드 메일을 받지 못했습니다.',
      a3: `원타임 패스워드 메일이 도착하지 않는 경우, 스팸메일함을 확인해 주세요. 또한, 도메인을 지정한 경우 '@linktivity.co.jp'를 허용하도록 설정해 주시기 바랍니다. 그래도 수신이 되지 않는다면, 이메일 주소가 잘못되었을 가능성이 있습니다. 올바른 이메일 주소를 입력하거나 다른 이메일 주소를 시도해 보세요.`,
      q4: '원타임 패스워드를 보낼 이메일 주소를 변경할 수 있나요?',
      a4: `원타임 패스워드를 보내는 이메일 주소는 변경할 수 없습니다. 원타임 패스워드 인증이 완료되면 이후부터는 등록한 이메일 주소로 일회용 비밀번호가 발송됩니다. E-ticket을 이용할 단말기(당일 현지에 가져갈 스마트폰 등)에서 확인할 수 있는 이메일 주소를 등록하는 것을 추천한다.`,
      q5: '보낸적이 없는 원타임 패스워드 메일을 여러 번  받았습니다.',
      a5: `다음과 같은 가능성이 있습니다.
  ・동반자에게 E-ticket(바우처)을 전송한 경우:
  고객이 E-ticket을 열고 원타임 패스워드 인증을 한 후, 동반자가 E-ticket을 열려고 하면 다른 단말기이므로 원타임 패스워드 메일이 전송됩니다.
  이때, 일회용 비밀번호의 발송처가 고객님의 이메일 주소(일회용 비밀번호 인증 시 등록한 이메일 주소)로 고정되어 있기 때문에 동반자가 E-Ticket에 접속한 시점에 여러 번 메일이 발송될 수 있습니다.
  
  ・부정사용:  만약 동반자에게 티켓을 전송하지 않은 경우, 부정사용의 가능성이 있으므로, 검토 후 필요시 예약 취소후 재예약을 권해드립니다.`,
      q6: '모르는 이메일 주소로 원타임 패스워드가 발송되었습니다.',
      a6: `다음과 같은 가능성이 있습니다.
  ・동반자에게 E-ticket(바우처)을 전송한 경우:
  고객이 E-ticket을 열고 원타임 패스워드 인증을 한 후, 동반자가 E-ticket을 열려고 하면 다른 단말기이므로 원타임 패스워드 메일이 전송됩니다.
  이때, 일회용 비밀번호의 발송처가 고객님의 이메일 주소(일회용 비밀번호 인증 시 등록한 이메일 주소)로 고정되어 있기 때문에 동반자가 E-Ticket에 접속한 시점에 여러 번 메일이 발송될 수 있습니다.
  
  ・부정사용: 만약 동반자 이외의 메일 주소로 전송된 경우, 부정사용의 가능성이 있으므로, 검토 후 필요시 예약 취소후 재예약을 권해드립니다.`
    }
  }
};
